import { render } from "./PartyMain.vue?vue&type=template&id=5c2c8079"
import script from "./PartyMain.vue?vue&type=script&lang=js"
export * from "./PartyMain.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__